import React, { Fragment, PureComponent, ReactNode } from 'react';

import { FormattedMessage } from 'react-intl';

import CustomThemeButton from '@atlaskit/button/custom-theme-button';

import Loading from 'src/components/loading';
import authRequest from 'src/utils/fetch';

import * as styles from './details-list.style';
import messages from './repository-details-modal.i18n';

type DetailsListProps<T> = {
  requestUrl: string;
  render: (items: T[]) => ReactNode;
};

type DetailsListState<T> = {
  error: boolean;
  isLoading: boolean;
  listItems: T[];
  nextUrl: string;
};

export default class DetailsList<T> extends PureComponent<
  DetailsListProps<T>,
  DetailsListState<T>
> {
  constructor(props: DetailsListProps<T>) {
    super(props);

    this.state = {
      error: false,
      isLoading: false,
      listItems: [],
      nextUrl: '',
    };
  }

  componentDidMount() {
    this.fetchDetailsList(this.props.requestUrl);
  }

  fetchDetailsList = async (requestUrl: string) => {
    this.setState({ isLoading: true });

    const { listItems } = this.state;

    try {
      const response = await fetch(authRequest(requestUrl));

      if (!response.ok) {
        throw Error();
      }

      const json = await response.json();
      const { values: newItems, next: nextUrl = '' } = json;

      this.setState({
        error: false,
        isLoading: false,
        listItems: listItems.concat(newItems),
        nextUrl,
      });
    } catch (e) {
      this.setState({
        error: true,
        isLoading: false,
        nextUrl: '',
      });
    }
  };

  render() {
    const { error, isLoading, listItems, nextUrl } = this.state;

    if (error) {
      // TODO: Add error state
      // https://softwareteams.atlassian.net/browse/BBCDEV-10325
    }

    return (
      <Fragment>
        {this.props.render(listItems)}
        <styles.DetailsListFooter>
          {nextUrl && (
            <CustomThemeButton
              appearance="link"
              isLoading={isLoading}
              onClick={() => this.fetchDetailsList(nextUrl)}
              shouldFitContainer
              spacing="none"
            >
              <FormattedMessage {...messages.showMore} />
            </CustomThemeButton>
          )}
          {isLoading && !nextUrl && <Loading size="small" />}
        </styles.DetailsListFooter>
      </Fragment>
    );
  }
}
